export default "__VITE_ASSET__DMc90hNr__"